module.exports = __webpack_public_path__ + "static/img/9.5a4f302.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/9.png
// module id = Qa2P
// module chunks = 0